module.exports = __webpack_public_path__ + "3c6774a83082ad1e6ef24f9b83621ab8.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/difficulty_1.png
// module id = 36
// module chunks = 0